<template>
  <el-dialog
    :visible.sync="isVisible"
    title="Upload Invoice"
    width="70vw"
    top="5vh"
    :close-on-click-modal="false"
    :fullscreen="isFullscreen"
    @closed="$emit('destroy')"
  >
    <UploadForm
      ref="stepOne"
      v-loading="isUploading"
      :form="form"
      @submitted="submit"
    />
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click.native="isFullscreen = !isFullscreen">
        <FontAwesomeIcon
          v-if="isFullscreen"
          :icon="['fal', 'compress']"
        />
        <FontAwesomeIcon
          v-else
          :icon="['fal', 'expand']"
        />
      </el-button>
      <el-button @click.native="isVisible = false">
        Cancel
      </el-button>
      <el-button
        v-loading="isUploading"
        type="primary"
        @click.native="submit()"
      >
        Upload
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import UploadForm from '@/components/Application/Billing/CarrierInvoices/UploadForm'
import Request, { POST } from '@/plugins/sdk/Request'

export default {
  components: {
    UploadForm
  },
  data () {
    return {
      isFullscreen: false,
      isVisible: true,
      form: {
        account: null,
        carrier: null
      },
      isUploading: false
    }
  },
  methods: {
    async submit () {
      this.isUploading = true
      const uploadedFile = await this.$file.upload(this.form.file.raw, undefined, this.form.file.name, true)
      this.form.file_id = uploadedFile.data.file.id

      const request = await (Object.assign(new Request(), {
        method: POST,
        _pathname: 'carrierinvoices/import',
        body: this.form
      })).build()

      const response = await fetch(request)

      if (response.ok) {
        this.$message.success('Invoice Uploaded Successfully')
      } else {
        this.$message.error('Invoice Upload Failed')
      }

      this.isUploading = false
      this.isLoading = false
      this.isVisible = false
    }
  }
}
</script>
